import { Module } from 'vuex'

import { PostSubmissionUseCase } from '@/application/judge/postSubmissionUseCase'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface PostSubmissionState {
  judgeToken: string
  isLoading: boolean
  error: string | null
}

export const postSubmissionModule = (judgeRepository: JudgeRepository): Module<PostSubmissionState, any> => {
  const postSubmissionUseCase = new PostSubmissionUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      judgeToken: '',
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeToken(state, token: string) {
        state.judgeToken = token
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async postSubmission(
        { state, commit, dispatch },
        {
          problemId,
          programLanguage,
          sourceCode
        }: { problemId: string; programLanguage: ProgramLanguageType; sourceCode: string }
      ) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const newProgramLanguage = programLanguage.replace(' (Beta)', '') as ProgramLanguageType
          const token = await postSubmissionUseCase.postSubmission(problemId, newProgramLanguage, sourceCode)
          commit('setJudgeToken', token)
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      judgeToken: state => state.judgeToken,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
